import { defineStore } from "pinia"
import { ref, computed } from "vue"
import { getQuestions, getAudio } from "@/api/s3/index"
import { useHelpStore } from "@/components/af/Help/help.store.js"
import { moveBisActor } from "@/features/movebis/machines/moveBisMachine"
import type { Ref } from "vue"
import type { Question } from "@/features/movebis/store/movebis.types"

export const useQuestionsStore = defineStore("moveBisQuestionsStore", () => {
  const helpStore = useHelpStore()

  const initalItems: Ref<Question[]> = ref([])
  const items: Ref<Question[]> = ref([])
  const currentIndex: Ref<number> = ref(0)
  const isLastQuestion: Ref<boolean> = ref(false)
  const dimensions: Ref<string[]> = ref([])

  const currentQuestion = computed<Question>(() => {
    return items.value[currentIndex.value]
  })
  const questionsLength = computed(() => items.value.length)

  async function fetchQuestions() {
    const data = await getQuestions({ test: "movebis" })
    items.value = data.questions
    initalItems.value = data.questions

    items.value = items.value.filter(
      (item) => dimensions.value && dimensions.value.includes(item.dimension)
    )

    return items.value
  }

  function fetchAudios() {
    getAudio({ test: "movebis" })
  }

  // if current question is not the last one of the list, increment the index
  async function goNext() {
    if (currentIndex.value === items.value.length - 1) {
      isLastQuestion.value = true
      moveBisActor.send({ type: "done" })
    } else {
      currentIndex.value++
      if (helpStore.isAudioHelpAccepted) {
        helpStore.startAudioSequence()
      }
    }
  }

  function setCurrentIndex(id: number) {
    currentIndex.value = id
  }

  function setDimensions(_dimensions) {
    dimensions.value = _dimensions
  }

  function getItems() {
    return initalItems.value
  }

  return {
    getItems,
    questions: items.value,
    currentIndex,
    currentQuestion,
    questionsLength,
    fetchQuestions,
    fetchAudios,
    goNext,
    isLastQuestion,
    setCurrentIndex,
    setDimensions,
  }
})
